import { useState, useEffect } from "react";

export const ImagePreloader = (images) => {
  const [preloadedImages, setPreloadedImages] = useState([]);
  useEffect(() => {
    let loadedCount = 0;
    const loadedImages = [];

    const preloadImages = () => {
      images.forEach((image) => {
        const img = new Image();
        img.src = image;
        img.onload = () => {
          loadedCount++;
          loadedImages.push(img.src);
          if (loadedCount === images.length) {
            setPreloadedImages(loadedImages);
          }
        };
      });
    };

    preloadImages();
  }, [images]);

  return preloadedImages;
};
